import React, { useState, useEffect } from 'react';

function HistoricalBetCards({ bets }) {
  const [currentPage, setCurrentPage] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!bets || bets.length === 0) {
    return <p>Line blown, tap a fresh one</p>;
  }

  const itemsPerPage = isMobile ? 3 : 6;
  const totalPages = Math.ceil(bets.length / itemsPerPage);
  const startIndex = currentPage * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentBets = bets.slice(startIndex, endIndex);

  const handlePrevPage = () => {
    setCurrentPage((prev) => Math.max(0, prev - 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prev) => Math.min(totalPages - 1, prev + 1));
  };

  const cardStyle = {
    border: '2px solid #5a4a38',
    borderRadius: '4px',
    padding: '20px',
    backgroundColor: '#f4f1e8',
    boxShadow: '0 4px 8px rgba(0,0,0,0.4)',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    minHeight: '200px'
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
    gap: '20px',
    marginBottom: '20px'
  };

  return (
    <div>
      <div style={gridStyle}>
        {currentBets.map((bet) => (
          <div key={bet.id} style={cardStyle}>
            <p style={{ margin: '0 0 15px 0', fontSize: '16px', fontWeight: 'bold', color: '#2a2018', borderBottom: '2px solid #b8860b', paddingBottom: '10px' }}>
              "{bet.description}"
            </p>
            <div style={{ fontSize: '14px', color: '#3d3127' }}>
              <p style={{ margin: '5px 0' }}>
                <strong>Who called the round?</strong> {bet.creator_name}
              </p>
              {bet.requires_response && bet.creator_prediction && (
                <p style={{ margin: '5px 0' }}>
                  <strong>Creator's Prediction:</strong> {bet.creator_prediction}
                </p>
              )}
              <p style={{ margin: '5px 0' }}>
                <strong>Who's in the round</strong> {bet.participants_names ? bet.participants_names.join(', ') : 'N/A'}
              </p>
              <p style={{ margin: '5px 0' }}>
                <strong>Time called</strong> {new Date(bet.created_at).toLocaleDateString()}
              </p>
              <p style={{ margin: '5px 0' }}>
                <strong>Settling?</strong> {bet.status === 'resolved' ? 'yes' : 'no'}
              </p>
              <p style={{ margin: '5px 0' }}>
                <strong>To the victor goes the spoils</strong> {bet.winner_name}
              </p>
              {bet.requires_response && bet.actual_result && (
                <p style={{ margin: '5px 0' }}>
                  <strong>Actual Result:</strong> {bet.actual_result}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>

      {totalPages > 1 && (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '15px',
          marginTop: '20px'
        }}>
          <button
            onClick={handlePrevPage}
            disabled={currentPage === 0}
            style={{
              padding: '8px 16px',
              fontSize: '14px',
              cursor: currentPage === 0 ? 'not-allowed' : 'pointer',
              background: currentPage === 0 ? 'linear-gradient(145deg, #5a4a38, #3d3127)' : 'linear-gradient(145deg, #b8860b, #cd7f32)',
              color: currentPage === 0 ? '#8a8378' : '#1a1612',
              border: '2px solid ' + (currentPage === 0 ? '#3d3127' : '#daa520'),
              borderRadius: '3px',
              fontWeight: 'bold'
            }}
          >
            ← Previous
          </button>
          <span style={{ fontSize: '14px', color: '#f9f6f0', fontWeight: 'bold' }}>
            Page {currentPage + 1} of {totalPages}
          </span>
          <button
            onClick={handleNextPage}
            disabled={currentPage === totalPages - 1}
            style={{
              padding: '8px 16px',
              fontSize: '14px',
              cursor: currentPage === totalPages - 1 ? 'not-allowed' : 'pointer',
              background: currentPage === totalPages - 1 ? 'linear-gradient(145deg, #5a4a38, #3d3127)' : 'linear-gradient(145deg, #b8860b, #cd7f32)',
              color: currentPage === totalPages - 1 ? '#8a8378' : '#1a1612',
              border: '2px solid ' + (currentPage === totalPages - 1 ? '#3d3127' : '#daa520'),
              borderRadius: '3px',
              fontWeight: 'bold'
            }}
          >
            Next →
          </button>
        </div>
      )}
    </div>
  );
}

export default HistoricalBetCards;
